module.exports = __webpack_public_path__ + "static/ibm-plex-sans-v7-latin-italic-89a93a1bdde48c7bb104150de88affce.woff2";